<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Winter Blessings</title>
<link href="../styles/9780310354369_template.css" rel="stylesheet" type="text/css"/>
<section epub:type="chapter" title="Family Tree">
<p class="ftree" id="P4_2"><span class="right_1" epub:type="pagebreak" id="page_286" title="286"><a href="#/text/nav#rP4_2">F<span class="small">AMILY</span> T<span class="small">REE</span></a></span></p>
<p class="ftree1">Featuring <i>The Christmas Cat</i> novella characters from the collection <i>An Amish Christmas Love.</i></p>
<p class="center"><b>Thelma m. Alfred Bender</b></p>
<p class="num1">Mandy</p>
<p class="num1">Rhoda</p>
<p class="center"><b>Leona m. Marlin Blank</b></p>
<p class="num1">Darlene m. Uria Swarey</p>
<p class="num1">Ephraim</p>
<p class="num1">Katie Ann</p>
<p class="center"><b>Emma m. Henry (deceased) Bontrager</b></p>
<p class="num1">Hank the Cat</p>
<p class="center"><b>Darlene m. Uria Swarey</b></p>
<p class="num1">Savannah</p>
<p class="num1">Rebekah</p>
<p class="center"><b>Marietta m. Roman Hertzler</b></p>
<p class="num1">Clara</p>
<p class="center"><b>Gertrude m. Elvin King</b></p>
<p class="num1">Wayne</p>
<p class="center"><b>Feenie m. Jeptha Lantz</b></p>
<p class="num1">Arlan</p>
<p class="num1">Christian</p>
<p class="center"><b>Saloma m. Floyd Petersheim</b></p>
<p class="num1">Jerry</p>
<p class="num1">Biena</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310354369_Ftree_P4.vue?4c90e59c